"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportTablesToExcel = void 0;
var xlsx_1 = __importDefault(require("xlsx"));
var exportTablesToExcel = function (collectionRef, fields, titles, fileName) { return __awaiter(void 0, void 0, void 0, function () {
    var colSn, dataDocs, data, filename, worksheet, newWorkbook;
    return __generator(this, function (_a) {
        colSn = collectionRef;
        dataDocs = colSn.map(function (doc) {
            // return fields.map(fieldName => {
            //     const value = doc[fieldName]
            //     switch (fieldName) {
            //         case 'id':
            //             return doc.id
            //         case 'unitId' || 'cachedProductUnit':
            //             return globalUnitsData[value]?.name
            //         case 'categoryId':
            //             return globalCategoriesData[value]?.name
            //         case 'currencyId':
            //             return globalCurrenciesData[value]?.name
            //         case 'projectId' || 'toProjectId':
            //             return globalProjectsData[value]?.name
            //         case 'warehouseId' || 'toWarehouseId':
            //             return globalWarehousesData[value]?.name
            //         case 'budgetSectionId' || 'budgetLineId':
            //             return globalBudgetLinesData[value]?.code
            //         case 'donorId':
            //             return globalDonorsData[value]?.name
            //         case 'startingDate' || 'endingDate' || 'createdAt' || 'expiryDate' || 'updatedAt':
            //             return doc
            //                 .data()
            //                 [fieldName].toDate()
            //                 .toLocaleString()
            //         default:
            //             return value instanceof Array ? value.join(',') : value
            //     }
            // })
        });
        data = __spreadArray([titles], dataDocs, true);
        filename = fileName;
        worksheet = xlsx_1.default.utils.aoa_to_sheet(data);
        newWorkbook = xlsx_1.default.utils.book_new();
        xlsx_1.default.utils.book_append_sheet(newWorkbook, worksheet, fileName);
        xlsx_1.default.writeFile(newWorkbook, "".concat(filename, ".xls"));
        xlsx_1.default.readFile(filename);
        return [2 /*return*/];
    });
}); };
exports.exportTablesToExcel = exportTablesToExcel;
